import React, { FC } from 'react'
import useQA from 'hooks/useQA'
import styles from '../../Polaroid.module.scss'
import { DimensionsUnit } from 'components/MeasurementUnit'
import { getMediumMaterialText } from '../../helpers'
import { DimensionUnits } from 'components/MeasurementUnit/types'

type MediumMaterialDimensionsRowProps = {
  isMediumMaterialVisible?: boolean
  isDimensionsVisible?: boolean
  mediums?: ReadonlyArray<string>
  materials?: ReadonlyArray<string>
  dimensions?: DimensionUnits
  isDepthVisible?: boolean
  category: string
}

const MediumMaterialDimensionsRow: FC<MediumMaterialDimensionsRowProps> = ({
  isMediumMaterialVisible = true,
  isDimensionsVisible = true,
  mediums = [],
  materials = [],
  dimensions,
  isDepthVisible,
  category,
}) => {
  const { testId } = useQA()

  const hasMediumOrMaterial =
    isMediumMaterialVisible && (mediums.length > 0 || materials.length > 0)
  const hasDimensions = isDimensionsVisible && !!dimensions

  return (
    <div className={styles.polaroidMaterialAndDimensionsContainer}>
      {hasMediumOrMaterial && (
        <>
          <p className={styles.textGunmetalOpacity} {...testId('medium-material')}>
            {getMediumMaterialText(mediums, materials, category)}
          </p>

          {hasDimensions && <div className={styles.customDot} />}
        </>
      )}
      {hasDimensions && (
        <p className={styles.textGunmetalOpacity} {...testId('artwork-dimensions')}>
          <DimensionsUnit isDepthVisible={isDepthVisible} dimensions={dimensions} />
        </p>
      )}
    </div>
  )
}

export default MediumMaterialDimensionsRow
